import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b3715034"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-layout",
  "element-loading-text": "正在退出..."
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "技术支持：掌尚名医", -1));
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_menuLeft = _resolveComponent("menuLeft");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_Header = _resolveComponent("Header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  const _component_Socket = _resolveComponent("Socket");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      width: _ctx.menuLeftWidth,
      height: _ctx.clientHeight
    }, {
      default: _withCtx(() => [_createVNode(_component_menuLeft, {
        isCollapse: _ctx.isCollapse,
        menuLeftWidth: _ctx.menuLeftWidth,
        clientHeight: _ctx.clientHeight,
        routes: $options.routes
      }, null, 8, ["isCollapse", "menuLeftWidth", "clientHeight", "routes"])]),
      _: 1
    }, 8, ["width", "height"]), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_Header, {
        onIsCollapse: $options.collapseChange,
        onIsLoading: $options.isLoading
      }, null, 8, ["onIsCollapse", "onIsLoading"]), _createVNode(_component_el_main, null, {
        default: _withCtx(() => [!_ctx.isUrl ? (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        })) : (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          src: _ctx.menuUrl,
          width: "100%",
          height: "100%"
        }, null, 8, _hoisted_2))]),
        _: 1
      }), _createVNode(_component_el_footer, {
        style: _normalizeStyle('padding-left:' + _ctx.menuLeftWidth)
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, [_createTextVNode("当前"), _createElementVNode("strong", null, _toDisplayString(_ctx.update_online_count), 1), _createTextVNode("人在线")]), _hoisted_3]),
        _: 1
      }, 8, ["style"])]),
      _: 1
    })]),
    _: 1
  }), _ctx.socketOpen ? (_openBlock(), _createBlock(_component_Socket, {
    key: 0,
    ref: "Socket",
    onCallBack: $options.newMessage
  }, null, 8, ["onCallBack"])) : _createCommentVNode("", true), _ctx.appointmentAutoMp3Show ? (_openBlock(), _createElementBlock("audio", {
    key: 1,
    src: _ctx.mp3Url,
    ref: "Audio",
    id: "myaudio",
    controls: "controls",
    loop: "false"
  }, null, 8, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.autoPlay && $options.autoPlay(...args)),
    ref: "playVideo",
    id: "payVideo"
  }, "Play Video", 512)])), [[_directive_loading, _ctx.loading]]);
}